export const ToolClicked = {
    DELETE: 'delete',
    ZOOMIN: 'zoomIn',
    ZOOMOUT: 'zoomOut',
    UPLOAD: 'upload',
    DOWNLOAD: 'download'
}